import { BrandPlanTactics } from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/BrandPlanTactics'
import { BrandPlanTacticsNextData } from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/Types'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { BrandPlan } from 'types'
import { MultiStepPageLayout } from 'components/MultiStepFlow/MultiStepPageLayout/MultiStepPageLayout'
import { AutopilotSidebar } from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/AutopilotSidebar'
import AutopilotRegistrationAndOnboardingStyles from 'screens/AutopilotRegistration/AutopilotRegistrationAndOnboarding.module.scss'

export const Channels = ({
  onBack,
  onSubmit,
  brandPlan,
  isUpgradingBrandPlan,
  externalIntegrations,
  brandKitId,
}: {
  onBack: () => void
  onSubmit: (values: BrandPlanTacticsNextData) => void
  brandPlan: BrandPlan
  isUpgradingBrandPlan: boolean
  externalIntegrations?: ExternalIntegration[]
  brandKitId?: number
}) => {
  const handleNext = (data: BrandPlanTacticsNextData) => {
    onSubmit(data)
  }

  // BrandPlanTactics is exported as BrandPlanTacticsContainer which expects an id prop
  // It will fetch the brand plan internally, but we need to pass the id
  if (!brandPlan?.id) {
    return null
  }

  // Use MultiStepPageLayout to match onboarding styling with sidebar
  return (
    <MultiStepPageLayout
      currentStep={2}
      totalSteps={2}
      onBack={onBack}
      currentStepKey="channels"
      showBackButton={true}
      siderComponent={AutopilotSidebar}
      backgroundClassName={AutopilotRegistrationAndOnboardingStyles.cloudBackground}
    >
      <BrandPlanTactics
        id={brandPlan.id}
        onBack={onBack}
        onNext={handleNext}
        externalIntegrations={externalIntegrations}
        brandKitId={brandKitId}
        tactics={brandPlan.tactics}
        seoKeywords={brandPlan.brand_profile?.keywords || []}
        idealCustomers={brandPlan.brand_profile?.ideal_customer_profiles || []}
        mode="campaign"
        skipBrandPlanUpdate={true}
        initialInsightChannels={[]}
      />
    </MultiStepPageLayout>
  )
}
